import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectSprayEventForSubmissionSprayEventOperations } from 'services/sprayEventsForSubmission/selectors';
import { selectPeopleArray } from 'services/people/selectors';
import { SprayEventOperation } from 'services/sprayEvents/types';

const selectSprayEventOperatorNames = createDeepEqualSelector(
    makeSelectSprayEventForSubmissionSprayEventOperations(),
    selectPeopleArray,
    (sprayEventOperations, people) =>
        people
            ?.filter(
                (person) =>
                    sprayEventOperations
                        ?.map(
                            (operator: SprayEventOperation) =>
                                operator.operatorPersonId
                        )
                        .includes(person.id as number)
            )
            .map((person) => person.fullName)
            .join(', ')
);
export { selectSprayEventOperatorNames };
